import { mediaQueries, style, Text } from '@do/walrus';
import React from 'react';
import styled from 'styled-components';

const PolicyText = styled(Text)`
  padding: 10px 0 10px 10px;
  max-width: ${style.viewports.small}px;
  ${mediaQueries.xsmallMax} {
    max-width: 350px;
  }
`;

const TermsAndPolicy = () => {
  return (
    <PolicyText type="small" tertiary>
      By continuing, you agree to the DigitalOcean{' '}
      <a target="_blank" rel="noopener noreferrer" href="https://www.digitalocean.com/legal/terms-of-service-agreement">
        Terms of Service
      </a>
      , the{' '}
      <a target="_blank" rel="noopener noreferrer" href="https://www.digitalocean.com/legal/privacy-policy">
        Privacy Policy
      </a>
      , and other relevant policies. This site uses cookies. See our{' '}
      <a target="_blank" rel="noopener noreferrer" href="https://www.digitalocean.com/legal/cookie-policy">
        Cookie Policy{' '}
      </a>{' '}
      for more information.
    </PolicyText>
  );
};

export default TermsAndPolicy;
